import { render, staticRenderFns } from "./GuideBookPaperCoverCard.vue?vue&type=template&id=a804a018"
import script from "./GuideBookPaperCoverCard.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperCoverCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports